export default __webpack_public_path__ + "static/media/Hammer of the Howling Giant.6706f3ca.jpg";